export const ArrowUp16 = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M5.47656 5.88043L8.16656 3.19043L10.8566 5.88043M8.16667 12.857L8.16667 3.52366"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
